import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { DashboardService } from '../../../api/dashboard/dashboard.service';
import { DashModel } from '../../../api/dashboard/DashModel';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable'
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { PasswordService } from '../../../api/password/password.service';
import { SelectApplication } from '../../../api/password/app';
import { CountryGroupService } from '../../../api/countrygroup/countrygroup.service';
import { ComboCountryGroup } from '../../../api/countrygroup/combocountrygroup';
import { ApplicationService } from '../../../api/application/application.service';
import { ComboApplication } from '../../../api/application/comboapplication';

import { ChatService } from '../../../api/chat/chat.service';

import { ApiConstant } from '../../../api/api.constant';

import 'rxjs/Rx';
import { NumberValueAccessor } from '@angular/forms/src/directives';
declare var $: any;
declare var jQuery: any;
declare var autosize: any;
declare var Ladda: any;
declare var Chartist: any;
@Component({
    selector: 'cat-page',
    templateUrl: './alpha.html'
})
export class DashboardsAlphaComponent implements OnInit {

    displaytimer : string;
    autoRefreshValue : string = "20";

    counter = 0;
    interval;
    countTime=20;

    totalAlliOSActive : number = 0;
    totalAlliOSSubscripton : number = 0;
    totalAllAndroidActive : number = 0;
    totalAllAndroidSubscripton : number = 0;
    totalAllSubscripton : number = 0;
    totalAllAccountCreate : number = 0;

    dashapplications: any = [];
    countryGroupList: ComboCountryGroup[];
    selectCountryGroupID: string;
    applicationList: ComboApplication[];
    deshboardData: DashModel;
    roleType: string;
    totalpendingTasks: string;
    progressPer :string = "0%";
    constructor(private apiservice : ApiConstant,private chatService : ChatService ,private dashboardService: DashboardService, public passwordService: PasswordService, private countrygroupService: CountryGroupService,
        private applicationService: ApplicationService,
        private router: Router, private location: Location) {
    }
    onChange(countryGroupValue) {
        this.selectCountryGroupID = countryGroupValue;
        this.sDashboard()
    }
    ngOnInit() {
        if (localStorage.getItem('id_token') && (localStorage.getItem('type') == 'SUPERADMIN' || localStorage.getItem('type') == 'ADMIN' || localStorage.getItem('type') == 'GENEROSITY')) {
            if(!this.apiservice.isChatAPICall)
            {
                this.chatService.unreadMessageCount("").then(data => {
                    this.apiservice.isChatAPICall = true;
                });
            }
            $(function () {
                $("[data-toggle=popover]").popover();
                $("[data-toggle=popover-hover]").popover({
                    trigger: 'hover'
                });
                $("[data-toggle=tooltip]").tooltip();

            });
            this.applicationList = [];
            this.countryGroupList = [];
            this.progressPer = "0%";
            this.selectCountryGroupID = "All";
            this.deshboardData = new DashModel();
            this.dashapplications = [];
            this.roleType = localStorage.getItem("type");
            if(this.roleType == "GENEROSITY")
            {
                this.sDashboard();
            }
            else
            {
                this.countrygroupService
                .ComboCountryGroup()
                .then(data => {
                    this.countryGroupList = data;
                    this.progressPer = "25%";
                    this.applicationService
                        .ComboApplication()
                        .then(data => {
                            this.progressPer = "55%";
                            this.applicationList = data;
                        }).then(dttt => {
                            this.sDashboard()
                        })
                });
            }
           
        } else {
            this.router.navigate(['/']);
        }
    }
    sDashboard() {

        if (this.selectCountryGroupID == undefined || this.selectCountryGroupID == null || this.selectCountryGroupID == "") {
            $.notify({
                message: "Please Select Country Group."
            }, {
                type: 'danger',
                placement: {
                    from: 'bottom',
                    align: 'left'
                },
                delay: 100,
                timer: 200
            });
            return;
        }
        this.counter = 0
        clearInterval(this.interval)
        this.progressPer = "55%";
        var JData = {
            countrygroupId: this.selectCountryGroupID
        }
        this.dashboardService.allDashboard(JData).then(data => {
            this.progressPer = "100%";
            if (!data.status) {
                $.notify({
                    message: "Fail To Load Deshboard Data."
                }, {
                    type: 'danger',
                    placement: {
                        from: 'bottom',
                        align: 'left'
                    },
                    delay: 100,
                    timer: 200
                });
            }
            if (data.status) {
                this.deshboardData = data.data[0];
            }
            this.deshboardData.totaluser = this.deshboardData.totaluser == undefined ? 0 : this.deshboardData.totaluser;
            this.deshboardData.totaltodayregister = this.deshboardData.totaltodayregister == undefined ? 0 : this.deshboardData.totaltodayregister;
            this.deshboardData.totaltodayactive = this.deshboardData.totaltodayactive == undefined ? 0 : this.deshboardData.totaltodayactive;

            this.deshboardData.totalandroiddevice = this.deshboardData.totalandroiddevice == undefined ? 0 : this.deshboardData.totalandroiddevice;
            this.deshboardData.todayandroidregister = this.deshboardData.todayandroidregister == undefined ? 0 : this.deshboardData.todayandroidregister;
            this.deshboardData.todayandroidactive = this.deshboardData.todayandroidactive == undefined ? 0 : this.deshboardData.todayandroidactive;

            this.deshboardData.totaliosdevice = this.deshboardData.totaliosdevice == undefined ? 0 : this.deshboardData.totaliosdevice;
            this.deshboardData.todayiosregister = this.deshboardData.todayiosregister == undefined ? 0 : this.deshboardData.todayiosregister;
            this.deshboardData.todayiosactive = this.deshboardData.todayiosactive == undefined ? 0 : this.deshboardData.todayiosactive;

            this.deshboardData.totalhuaweidevice = this.deshboardData.totalhuaweidevice == undefined ? 0 : this.deshboardData.totalhuaweidevice;
            this.deshboardData.todayhuaweiregister = this.deshboardData.todayhuaweiregister == undefined ? 0 : this.deshboardData.todayhuaweiregister;
            this.deshboardData.todayhuaweiactive = this.deshboardData.todayhuaweiactive == undefined ? 0 : this.deshboardData.todayhuaweiactive;

            this.deshboardData.applelogin = this.deshboardData.applelogin == undefined ? 0 : this.deshboardData.applelogin;
            this.deshboardData.facebooklogin = this.deshboardData.facebooklogin == undefined ? 0 : this.deshboardData.facebooklogin;
            this.deshboardData.huaweilogin = this.deshboardData.huaweilogin == undefined ? 0 : this.deshboardData.huaweilogin;
            this.deshboardData.googlelogin = this.deshboardData.googlelogin == undefined ? 0 : this.deshboardData.googlelogin;
            this.deshboardData.emaillogin = this.deshboardData.emaillogin == undefined ? 0 : this.deshboardData.emaillogin;
            this.deshboardData.guestlogin = this.deshboardData.guestlogin == undefined ? 0 : this.deshboardData.guestlogin;
            this.deshboardData.normallogin = this.deshboardData.normallogin == undefined ? 0 : this.deshboardData.normallogin;

            this.deshboardData.totalactive = this.deshboardData.totalactive == undefined ? 0 : this.deshboardData.totalactive;
            this.deshboardData.totalcancel = this.deshboardData.totalcancel == undefined ? 0 : this.deshboardData.totalcancel;
            this.deshboardData.totalinactive = this.deshboardData.totalinactive == undefined ? 0 : this.deshboardData.totalinactive;

            this.deshboardData.totaluser = this.deshboardData.totalandroiddevice + this.deshboardData.totaliosdevice + this.deshboardData.totalhuaweidevice;
            this.deshboardData.totaltodayregister = this.deshboardData.todayandroidregister + this.deshboardData.todayiosregister + this.deshboardData.todayhuaweiregister;
            this.deshboardData.totaltodayactive = this.deshboardData.todayandroidactive + this.deshboardData.todayiosactive + this.deshboardData.todayhuaweiactive;

            this.dashapplications = [];

            this.totalAlliOSActive = 0;
            this.totalAlliOSSubscripton = 0;
            this.totalAllAndroidActive = 0;
            this.totalAllAndroidSubscripton = 0;
            this.totalAllSubscripton = 0;
            this.totalAllAccountCreate = 0;
            for (let index1 = 0; index1 < data.applications.length; index1++) {
                var element1 = data.applications[index1];
                if(element1.length > 0)
                {
                    this.totalAlliOSActive += element1[0].iosdevice;
                    this.totalAlliOSSubscripton += element1[0].iossubscription;
                    this.totalAllAndroidActive += element1[0].androiddevice;
                    this.totalAllAndroidSubscripton += element1[0].androidsubscription;
                    element1[0].totalsubscription = element1[0].iossubscription + element1[0].androidsubscription;
                    this.totalAllSubscripton += element1[0].totalsubscription;

                    this.totalAllAccountCreate += element1[0].accountcreate;

                    this.dashapplications.push(element1[0]);
                }
            }
            this.progressTimeOut();
            this.interval = setInterval(() => { this.incrementvar(); }, 1000);
        });
    }
    progressTimeOut()
    {
      setTimeout(()=>
      { 
        this.progressPer = "0%"; 
      },200);
    }
    incrementvar() {
        if(this.autoRefreshValue != "Off")
        {
            this.counter--;
            var total = this.countTime + this.counter;
            if(total <= 0)
            {
                total = 0;
            }
            this.displaytimer = this.formatTime(total);
            if (total <= 0) {
                this.counter = 0
                this.sDashboard()
            }
        }
        else
        {
            clearInterval(this.interval)
        }
    }
    onAutoRefreshChange(valll)
    {
        this.autoRefreshValue = valll;
        if(valll != "Off")
        {
            this.countTime = parseInt(valll);
            this.counter = 0;
            var total = this.countTime + this.counter;
            this.displaytimer = this.formatTime(total);
            this.sDashboard()
        }
    }
    formatTime(time) {   
        // Hours, minutes and seconds
        var hrs = ~~(time / 3600);
        var mins = ~~((time % 3600) / 60);
        var secs = ~~time % 60;
    
        // Output like "1:01" or "4:03:59" or "123:03:59"
        var ret = "";
        if (hrs > 0) {
            ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }
        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/dashboards/alpha.page.ts